import type { SocialLink } from '@/types';
import { profile } from '@/data/profile';

export const socialLinks: SocialLink[] = [
  {
    id: 'github',
    platform: 'github',
    label: 'GitHub',
    href: profile.githubUrl,
    external: true,
  },
  {
    id: 'email',
    platform: 'email',
    label: 'Email',
    href: `mailto:${profile.email}`,
  },
  {
    id: 'website',
    platform: 'website',
    label: 'Website',
    href: profile.websiteUrl,
    external: true,
  },
  {
    id: 'linkedin',
    platform: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/muhammadsufyan/',
    external: true,
  },
];
